module.exports = __webpack_public_path__ + "static/media/hypebeast.31776ee7.svg";